const e = {
  name: "CheckboxDouble",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30.2,16L26,11.8l-8,8l-4-4L9.8,20l8.2,8.2L30.2,16z M18,22.6l8-8l1.4,1.4L18,25.4L12.6,20l1.4-1.4L18,22.6z"
			/>
		<path class="st0" d="M9,0C4,0,0,4,0,9v22c0,5,4,9,9,9h22c5,0,9-4,9-9V9c0-5-4-9-9-9H9z M2,9c0-3.9,3.1-7,7-7h22c3.9,0,7,3.1,7,7
			v22c0,3.9-3.1,7-7,7H9c-3.9,0-7-3.1-7-7V9z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as CheckboxDouble
};
